<template>
  <div class="notice">
    <div class="title"><span>快速导航</span></div>
    <ul>
      <li v-for="(item, index) in columnList" :key="index" class="flex">
        <span class="flex-box" @click="navHandle(item.strId)">{{ item.strName }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {};
  },
  props: {
    columnList: {
      type: Array,
      default: () => [],
    },
  },
  created() {},
  methods: {
    // 更多菜单跳转
    navHandle(strId) {
      this.$router.push({ path: "/list", query: { strId: strId, strWebSiteId: this.$route.query.strWebSiteId } });
    },
  },
};
</script>

<style scoped lang="less">
.notice {
  border: solid 1px #ccc;
  width: 225px;
  min-height: 500px;
  .title {
    width: 90%;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    border-bottom: 2px solid #ccc;
    height: 37px;
    span {
      box-sizing: border-box;
      display: inline-block;
      color: #4a4a4a;
      font-size: 18px;
      height: 37px;
      line-height: 37px;
      padding: 0 20px;
      border-bottom: 2px solid #df3036;
    }
  }
  ul {
    box-sizing: border-box;
    padding: 10px 10px 5px;
    margin: 0;
    li {
      box-sizing: border-box;
      padding: 0 0 0 20px;
      margin-top: 10px;
      font-size: 14px;
      color: #fff;
      width: 200px;
      height: 40px;
      line-height: 40px;
      background: url("../../assets/images/nav-bg.png") no-repeat center center;
      background-size: 100% 100%;
      cursor: pointer;
      span {
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      i {
        font-style: normal;
        color: #999;
        font-family: "SimSun";
      }
    }
  }
}
</style>